export default __webpack_public_path__ + "static/media/refreshIcon.d54e54e0.svg";